//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapState } from "vuex";
import router from "../../router";
import logger from "@/utils/logger";

export default {
  data() {
    return {
      disabledSaveReturnButton: false,
      order: {},
      orderStatus: "",
      orderNumber: "",
      id: 0,

      dense: true,
      orderDate: date.formatDate(Date.now(), "DD-MM-YYYY"),
      deliveryDate: date.formatDate(Date.now(), "DD-MM-YYYY"),

      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
      },
      loadComplete: false,
      selected: [],
      showReturnTypeDialog: false,
      showLocationDialog: false,
      showSerialNumbersDialog: false,
      showCommentDialog: false,
      showReturnTransactions: false,
      showSaveReturnError: false,
      saveReturnErrors: 0,
      saveReturnErrorMessage: "",
      customers: [],
      selectedLine: {},
      stock: [],
      returnRows: [],
      showConfirmDeleteDlg: false,
      deleteRowId: -1,
      returnTransactions: [],
      warehouseId: -1,
      returnTypeId: 0,
      restQuantity: 0,
      Location: null,
      lineQuantity: 0,
      returned: 0,
      volume: 0,
      serialNumbers: [],
      comment: "",
      ReturnTypes: [],
      Warehouses: [],
      FilterWarehouses: [],
      Locations: [],
      FilterLocations: [],

      columns: [
        {
          name: "productNumber",
          align: "left",
          label: this.$t("order.productNumber"),
          field: "productNumber",
          style: "width: 200px",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: this.$t("order.productName"),
          field: "productName",
          sortable: true,
        },
        {
          name: "itemText",
          align: "left",
          label: this.$t("order.itemText"),
          field: "itemText",
          sortable: true,
        },
        {
          name: "quantity",
          align: "right",
          label: this.$t("order.quantity"),
          field: "numberOfItems",
          style: "width: 100px",
          sortable: true,
        },
        {
          name: "returned",
          align: "right",
          label: this.$t("order.qtyReturned"),
          field: "returned",
          style: "width: 100px",

          sortable: true,
        },
        {
          name: "joinedSerialNumbers",
          align: "left",
          label: this.$t("pick.serialNumbers"),
          field: (row) => row.joinedSerialNumbers,
          style: "max-width: 200px;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
      ],
      returnColumns: [
        {
          name: "productNumber",
          align: "left",
          label: this.$t("order.productNumber"),
          field: "productNumber",
          style: "width: 150px",
          sortable: true,
        },
        {
          name: "itemText",
          align: "left",
          label: this.$t("order.itemText"),
          field: "itemText",
          sortable: true,
        },
        {
          name: "returnTypeName",
          align: "left",
          label: this.$t("return.returnType"),
          field: "returnTypeName",
          sortable: true,
        },
        {
          name: "returnQty",
          align: "right",
          label: this.$t("common.quantity"),
          field: "returnQty",
          sortable: true,
        },
        {
          name: "locationName",
          align: "left",
          label: this.$t("stock.location"),
          field: "locationName",
          sortable: true,
        },
        {
          name: "joinedSerialNumbers",
          align: "left",
          label: this.$t("pick.serialNumbers"),
          field: "joinedSerialNumbers",
          style: "max-width: 300px;",
          sortable: true,
        },
        {
          name: "comment",
          align: "left",
          label: this.$t("order.comment"),
          field: "comment",
          style: "max-width: 300px;",
          sortable: true,
        },
      ],
      transactionColumns: [
        {
          name: "productName",
          align: "left",
          label: this.$t("stock.product"),
          field: "productName",
          sortable: true,
        },
        {
          name: "returnType",
          align: "left",
          label: this.$t("return.returnType"),
          field: (row) => this.ReturnTypes[row.returnTypeId].name,
          style: "max-width: 300px;",
          sortable: true,
        },
        {
          name: "returned",
          align: "right",
          label: this.$t("order.qtyReturned"),
          field: "returned",
          sortable: true,
        },
        {
          name: "warehouseName",
          align: "left",
          label: "Lager",
          field: "warehouseName",
          sortable: true,
        },
        {
          name: "locationName",
          align: "left",
          label: this.$t("order.locationName"),
          field: "locationName",
          sortable: true,
        },
        {
          name: "comment",
          align: "left",
          label: this.$t("order.comment"),
          field: "comment",
          style: "max-width: 300px;",
          sortable: true,
        },
        {
          name: "serialNumbers",
          align: "left",
          label: this.$t("pick.serialNumbers"),
          field: "serialNumbers",
          style: "max-width: 300px;",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("main", ["warehouses", "locations", "user"]),
  },

  watch: {
    warehouseId(newValue, oldValue) {
      if (
        newValue != oldValue &&
        this.Location != null &&
        this.Location.warehouseId != newValue
      ) {
        this.Location = null;
      }
    },

    Location(newValue, oldValue) {
      if (newValue != oldValue) {
        var loc = this.Locations.filter((l) => {
          return newValue && l.id == newValue.id;
        });
        if (loc && loc.length > 0 && this.warehouseId != loc[0].warehouseId) {
          this.warehouseId = loc[0].warehouseId;
        }
      }
    },

    serialNumbers(newValue, oldValue) {
      if (newValue != oldValue) {
        for (var i = 0; i < newValue.length; i++) {
          var test = newValue[i].split(",");
          if (test.length > 1) {
            newValue[i] = test[0];
            for (var j = 1; j < test.length; j++) {
              if (test[j]) {
                newValue.push(test[j]);
              }
            }
          }
        }
      }
    },
  },

  methods: {
    async refresh() {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.loadComplete = false;
      this.selected = [];
      this.returnRows = [];
      this.id = this.$route.params.id;
      if (this.id > 0) {
        await this.fetchOrder(this.id);
      }

      setTimeout(() => {
        notif();
      }, 500);
    },

    journalIsBlack(row) {
      if (row.returnTransactions.length > 0) {
        return row.returnTransactions.every((t) => t.journalEntryNumber != null);
      }
    },

    async itemsChanged(data) {
      this.order = data;
      this.setOrderStatus();
    },

    async fetchOrder(id) {
      const data = await this.getReturnOrder(id);
      this.order = data;
      this.orderNumber = this.order.orderNumber.toString();
      this.mapOrder(data);
      this.setOrderStatus();
      this.loadComplete = true;
    },

    mapOrder(data) {
      (this.orderDate = date.formatDate(data.orderDate, "DD-MM-YYYY")),
        (this.deliveryDate = date.formatDate(data.deliveryDate, "DD-MM-YYYY"));
    },

    setOrderStatus() {
      this.orderStatus = this.$t(
        "order.status-" + this.order.customerOrderStatusId
      );
    },

    createReturnRows() {
      for (var i = 0; i < this.selected.length; i++) {
        var item = this.selected[i];
        var maxReturnQuantity =
          Math.abs(item.numberOfItems) -
          item.returned -
          this.sumItemReturnRows(item.id);
        if (maxReturnQuantity > 0) {
          var returnRow = {};
          returnRow.custmerOrderItem = item;
          returnRow.returnTypeId = this.returnTypeId;
          returnRow.returnTypeName = this.ReturnTypes[
            returnRow.returnTypeId
          ].name;
          returnRow.productNumber = item.productNumber;
          returnRow.itemText = item.itemText;
          returnRow.pickedLocation = item.location;
          if (item.numberOfItems < 0) {
            returnRow.returnQty = maxReturnQuantity;
          }
          returnRow.location = item.location;
          returnRow.locationName =
            !this.useLocationForReturnType(returnRow.returnTypeId)
              ? "(NA)"
              : item.stockControlled
              ? "Må angis"
              : "(ikke lagerført)";
          returnRow.serialNumbers = item.serialNumberEnabled ? [] : null;
          returnRow.joinedSerialNumbers = this.joineSerialNumbers(
            returnRow.serialNumbers
          );
          returnRow.comment = "";
          returnRow.stock = item.stock;
          this.returnRows.push(returnRow);
     
        }
      }
      this.selected = [];
    },

    joineSerialNumbers(serialNumbers) {
      if (serialNumbers == null) return "(NA)";
      if (serialNumbers.length == 0) return "Må angis";
      let result = "";
      for (let i = 0; i < serialNumbers.length; i++) {
        result = result.concat(serialNumbers[i]);
        if (i < serialNumbers.length - 1) {
          result = result.concat(",");
        }
      }
      return result;
    },

    showDeleteConfirm(index) {
      this.deleteRowId = index;
      this.showConfirmDeleteDlg = true;
    },
    deleteLine() {
      if (this.deleteRowId > -1) {
        this.returnRows.splice(this.deleteRowId, 1);
      }
      this.deleteRowId = -1;
    },

    onReturnTypeClick(row) {
      this.returnTypeId = row.returnTypeId || 0;
      this.selectedLine = row;
      this.showReturnTypeDialog = true;
    },
    saveReturnType(forAllReturnRows) {
      if (forAllReturnRows) {
        for (var i = 0; i < this.returnRows.length; i++) {
          this.updateReturnType(this.returnRows[i]);
        }
      } else if (this.selectedLine) {
        this.updateReturnType(this.selectedLine);
      }
      this.showReturnTypeDialog = false;
    },
    updateReturnType(row) {
      row.returnTypeId = this.returnTypeId;
      row.returnTypeName = this.ReturnTypes[this.returnTypeId].name;
      if (this.returnTypeId < 1) {
        row.returnQty = null;
        row.serialNumbers = row.custmerOrderItem.serialNumberEnabled
          ? []
          : null;
        row.joinedSerialNumbers = this.joineSerialNumbers(row.serialNumbers);
        row.comment = null;
      }
      if (this.useLocationForReturnType(this.returnTypeId)) {
        if (!row.location) {
          row.locationName = row.custmerOrderItem.stockControlled
            ? "Må angis"
            : "(ikke lagerført)";
        }
      } else {
        row.location = null;
        row.locationName = "(NA)";
      }
    },

    validateReturnQty(row) {
      this.selectedLine = row;
      if (
        row.returnQty > 0 &&
        this.sumItemReturnRows(row.custmerOrderItem.id) <=
          Math.abs(row.custmerOrderItem.numberOfItems) -
            row.custmerOrderItem.returned
      ) {
        if (
          row.custmerOrderItem.serialNumberEnabled &&
          row.serialNumbers.length != row.returnQty
        ) {
          this.serialNumbers = row.serialNumbers;
          this.showSerialNumbersDialog = true;
        }
      } else {
        row.returnQty = null;
        row.serialNumbers = row.custmerOrderItem.serialNumberEnabled
          ? []
          : null;
        row.joinedSerialNumbers = this.joineSerialNumbers(row.serialNumbers);
        this.showSerialNumbersDialog = false;
      }
    },
    onSerialNumbersClick(row) {
      this.selectedLine = row;
      if (row.custmerOrderItem.serialNumberEnabled) {
        this.serialNumbers = row.serialNumbers;
        this.showSerialNumbersDialog = true;
      } else {
        this.serialNumbers = null;
        this.showSerialNumbersDialog = false;
      }
    },
    saveSerialNumbers() {
      if (
        this.selectedLine &&
        this.selectedLine.custmerOrderItem.serialNumberEnabled
      ) {
        if (this.serialNumbers.length == this.selectedLine.returnQty) {
          this.selectedLine.serialNumbers = this.serialNumbers;
          this.selectedLine.joinedSerialNumbers = this.joineSerialNumbers(
            this.serialNumbers
          );
        }
      }
      this.showSerialNumbersDialog = false;
    },

    useLocationForReturnType(returnTypeId) {
      return returnTypeId === 1;
    },
    onLocationClick(row) {
      if (!row.custmerOrderItem?.stockControlled) return;
      if (!this.useLocationForReturnType(row.returnTypeId)) return;

      this.returnType = this.ReturnTypes[row.returnTypeId];

      const location = this.preditcReturnLocation(row);
      this.warehouseId = location?.warehouseId;
      this.Location = location;

      this.selectedLine = row;
      this.showLocationDialog = true;
    },
    preditcReturnLocation(row) {
      const stockList = row.stock ?? [];
      if (stockList.length === 0) return null;

      const available = stockList.filter(item => item.quantity > 0);
      const candidates = available.length ? available : stockList;

      const [first, ...rest] = candidates;
      var best = rest.reduce((best, item) => {
        if (item.quantity !== best.quantity) {
          return item.quantity > best.quantity ? item : best;
        }

        return (item.created ?? 0) > (best.created ?? 0) ? item : best;
      }, first);

      return this.locations.find(loc => loc.id === best.locationId) ?? null;
    },
    saveLocation(forAllReturnRows) {
      if (forAllReturnRows) {
        for (var i = 0; i < this.returnRows.length; i++) {
          if (
            this.returnRows[i].custmerOrderItem.stockControlled &&
            this.useLocationForReturnType(this.returnRows[i].returnTypeId)
          ) {
            this.returnRows[i].location = this.Location;
            this.returnRows[i].locationName = this.Location
              ? this.Location.locationName
              : "Må angis";
          }
        }
      } else if (
        this.selectedLine.custmerOrderItem.stockControlled &&
        this.useLocationForReturnType(this.selectedLine.returnTypeId)
      ) {
        this.selectedLine.location = this.Location;
        this.selectedLine.locationName = this.Location
          ? this.Location.locationName
          : "Må angis";
      }
      this.showLocationDialog = false;
    },

    onCommentClick(row) {
      if (row.returnTypeId > 0) {
        this.selectedLine = row;
        this.comment = row.comment;
        this.showCommentDialog = true;
      }
    },
    saveComment(forAllReturnRows) {
      if (forAllReturnRows) {
        for (var i = 0; i < this.returnRows.length; i++) {
          this.returnRows[i].comment =
            this.returnRows[i].returnTypeId > 0 ? this.comment : "";
        }
      } else if (this.selectedLine) {
        this.selectedLine.comment =
          this.selectedLine.returnTypeId > 0 ? this.comment : "";
      }
      this.showCommentDialog = false;
    },

    sumItemReturnRows(id) {
      var itemReturns = this.returnRows.filter(
        (x) => x.custmerOrderItem.id == id
      );
      var sum = 0;
      itemReturns.forEach((item) => {
        sum += item.returnQty;
      });
      return sum;
    },

    async SaveReturnItems() {
      try {
        this.disabledSaveReturnButton = true;
        this.showSaveReturnError = false;
        this.saveReturnErrors = 0;
        this.saveReturnErrorMessage = "";
        var returnItems = [];
 
        for (var i = 0; i < this.returnRows.length; i++) {
          var item = this.returnRows[i];
          var itemError = "";

          if (item.returnTypeId < 1) {
            itemError =
              "* Kan ikke returnere " +
              item.itemText +
              " pga manglende returtype. ";
            this.saveReturnErrorMessage +=
              (this.saveReturnErrorMessage ? "\n" : "") + itemError;
            this.saveReturnErrors++;
          }
          if (
            item.returnQty < 1 ||
            this.sumItemReturnRows(item.custmerOrderItem.id) >
              Math.abs(item.custmerOrderItem.numberOfItems) -
                item.custmerOrderItem.returned
          ) {
            itemError =
              "* Kan ikke returnere " +
              item.returnQty +
              " av " +
              item.itemText +
              " pga ugyldig antall. ";
            this.saveReturnErrorMessage +=
              (this.saveReturnErrorMessage ? "\n" : "") + itemError;
            this.saveReturnErrors++;
          }
          if (
            item.custmerOrderItem.serialNumberEnabled &&
            item.serialNumbers.length != item.returnQty
          ) {
            itemError =
              "* Kan ikke returnere " +
              item.itemText +
              " pga feil antall serienummer. ";
            this.saveReturnErrorMessage +=
              (this.saveReturnErrorMessage ? "\n" : "") + itemError;
            this.saveReturnErrors++;
          }
          // if (
          //   this.useLocationForReturnType(item.returnTypeId) &&
          //   !item.location
          // ) {
          //   itemError =
          //     "* Kan ikke returnere " +
          //     item.itemText +
          //     " pga manglende lokasjon. ";
          //   this.saveReturnErrorMessage +=
          //     (this.saveReturnErrorMessage ? "\n" : "") + itemError;
          //   this.saveReturnErrors++;
          // }

          if (this.saveReturnErrors == 0) {
            var returnTransaction = {};
            returnTransaction.customerOrderItemId = item.custmerOrderItem.id;
            returnTransaction.returnTypeId = item.returnTypeId;
            returnTransaction.locationId = item.location
              ? item.location.id
              : -1;
            returnTransaction.returnQuantity = item.returnQty;
            returnTransaction.serialNumbers = item.custmerOrderItem
              .serialNumberEnabled
              ? item.joinedSerialNumbers
              : null;
            returnTransaction.comment = item.comment;
            returnItems.push(returnTransaction);
          }
        }
       
        if (this.saveReturnErrors == 0 && returnItems.length > 0) {
          var returnOrder = {};
          returnOrder.id = this.order.id;
          returnOrder.items = returnItems;
 
          var saveMsg = await this.postReturnItems(returnOrder);
          if (!saveMsg) {
            this.saveReturnErrorMessage = "* Feilet i lagring av retur! ";
            this.saveReturnErrors++;
          } else {
            router.push({ name: "ReturnOrders" });
          }
          if (saveMsg && this.saveReturnErrors == 0) {
            this.$q.notify({
              type: "positive",
              message: this.$t("common.saveOk"),
            });
          } else {
            this.showSaveReturnError = true;
          }
        }
        else {
          this.showSaveReturnError = true;
        }
        this.disabledSaveReturnButton = false;
      } catch (err) {
        logger.log(err);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
        this.saveReturnErrorMessage = "* Feilet i lagring av retur: " + err;
        this.saveReturnErrors++;
        this.showSaveReturnError = true;
        this.disabledSaveReturnButton = false;
      }

      this.disabledSaveReturnButton = false;
    },

    // kun til å vise tidligere ruterer
    async showReturnTransactionsClick() {
      if (this.selected.length == 1) {
        this.returnTransactions = this.selected[0].returnTransactions;
      }
      this.showReturnTransactions = true;
    },

    getWarehouseFilter(val, update) {
      if (!this.Warehouses) {
        update();
        return;
      }
      update(() => {
        this.Warehouses = this.FilterWarehouses.filter(
          (w) =>
            !w.isDeleted &&
            w.warehouseName.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },

    getLocationsFilter(val, update) {
      if (!this.Locations) {
        update();
        return;
      }
      update(() => {
        this.Locations = this.stock.filter(
          (l) => this.warehouseId < 1 || l.warehouseId == this.warehouseId
        );
      });

      update(() => {
        this.Locations = this.locations.filter(
          (l) =>
            (this.warehouseId < 1 || l.warehouseId == this.warehouseId) &&
            l.locationName.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },

    async journalEntryPost(orderItemId) {
      const loading = this.$q.notify({ type: "ongoing", message: "Oppretter billag" });
      try {
        await this.postAddJournalentryReturn(orderItemId);
        await this.fetchOrder(this.id);
        loading();
        this.$q.notify({ type: "positive", message: "Vellyket" });
      } catch (err) {
        loading();
        logger.log(err.message);
        this.$q.notify({ type: "negative", message: this.$t("common.errorSave") + " " + err });
      }
    },

    resetForm() {
      this.returnTypeId = 0;
      this.returned = 0;
      this.warehouseId = -1;
      this.Location = null;
      this.serialNumbers = [];
      this.comment = "";
    },

    ...mapActions("main", ["getReturnOrder", "getCustomer", "postReturnItems", "postAddJournalentryReturn"]),
  },

  async created() {
    // GET request using fetch with error handling

    this.id = this.$route.params.id;
    if (this.id > 0) {
      await this.fetchOrder(this.id);

      this.Locations = this.locations;
      this.FilterLocations = this.locations;
      this.FilterWarehouses = this.warehouses;
      this.Warehouses = this.warehouses;

      let returnNames = [
        "",
        "Vare er ok",
        "Vare er ødelagt",
        "Vare er brukt",
        "DOA",
        "Ikke returner vare"
      ];
      for (var i = 0; i < returnNames.length; i++) {
        this.ReturnTypes.push({
          id: i,
          name: returnNames[i],
        });
      }
    }
  },
};
